// extracted by css-extract-rspack-plugin
export default {"Grabber":"ZbXGf","grabbing":"voztM"};